ApiPromise = undefined
queueRequire -> ApiPromise = require 'network/api-promise'
React = require 'react'
t = require('views/internal/recup-with-helpers')('manage_members')
l = require 'lib/localize'

trackUe = require 'debug/trackUe'


module.exports = class extends React.Component
  displayName: 'InvitationLink'

  constructor: (props) ->
    super(props)

    @state = {
      linkEnabled: false
      invitationUrl: ''
    }

  render: t.renderable ->
    { invitationUrl, linkEnabled } = @state


    t.div '.invitation-link-wrapper', =>
      t.div '.invitation-link-header', =>
        t.h4 ->
          t.img '.icon-share-link', { src: require('images/icon-link.svg') }
          t.format 'share-team-invite-link'

        if !linkEnabled
          t.a '.action-link', { href: '#', onClick: @showLink }, ->
            t.format 'create-link'

      if linkEnabled
        t.div =>
          t.div '.invitation-link-actions', =>
            t.input {
              type: 'text'
              readOnly: true
              placeholder: t.l 'loading'
              ref: @inputDidMount
              value: invitationUrl
              onClick: @copyInvitationLink
            }

            t.button '.button.primary', { onClick: => @copyInvitationLink({ target: @invitationInput }) }, ->
              t.format 'copy'
          t.a '.quiet', { href: '#', onClick: @deactivateInvitationLink }, ->
            t.format 'disable-this-link'

  showLink: =>
    trackUe('team view', 'opens', 'team invitation link', '', '', 'through members page invite menu', { teamId: @props.teamId })
    @setState linkEnabled: true

  inputDidMount: (input) =>
    @invitationInput = input
    if input
      { apiUrl, teamUrl } = @props

      ApiPromise
        method: 'post'
        url: "#{ apiUrl }/invitationSecret"
      .get 'secret'
      .then (secret) =>
        # Yes, this is gross … but eventually we won't be responsible for
        # forming these URLs anyway, since they should be coming from the server
        invitationUrl = teamUrl.replace ///
          (
            /b/[^/]+ # the /b/:shortlink portion of a board URL
            |
            /[^/]+$ # the /:orgname portion of an org URL
          )
          (.*)$
        ///, "/invite$1/#{ secret }$2"

        @setState { invitationUrl }
        input.focus()

      .done()

  deactivateInvitationLink: (e) =>
    { apiUrl } = @props

    @setState {
      invitationUrl: ''
      linkEnabled: false
    }
    trackUe('team view', 'disables', 'team invitation link', '', '', 'through members page invite menu', { teamId: @props.teamId })
    ApiPromise
      method: 'delete'
      url: "#{ apiUrl }/invitationSecret"
    .done()

  copyInvitationLink: ({ target }) =>
    target.select()
    trackUe('team view', 'copy', 'team invitation link', '', '', 'through members page invite menu', { teamId: @props.teamId })
    document.execCommand('copy')



// WEBPACK FOOTER //
// ./app/scripts/views/organization/manage-org-members-component/invitation-link.coffee